import React, { useEffect, useRef, useState } from 'react';
import { BannerToast } from '@toluna-ui-toolkit/toast';
import { CloseButton, ToastWrapper } from './Notifications.style';
import { useEvent } from '../../common/hooks/useEvent.hook';
import { notificationsEvents } from '../data/notifications.events';
import { Notification, NotificationData } from '../data/models';

interface INotificationsManagerProps {
    dismissText: string;
    onAdd?: (notifications: Notification[]) => void;
    onClose?: (notifications: Notification[]) => void;
}

const NotificationsManager = ({ dismissText, onAdd, onClose }: INotificationsManagerProps) => {
    const [notifications, setNotifications] = useState<Notification[]>([]);
    const ref = useRef(notifications); //only god knows why this is working

    const onCloseHandler = () => {
        const arrayCopy = [...ref.current];
        const firstNotification = arrayCopy.shift();
        setNotifications([...arrayCopy]);
        firstNotification?.onDismiss();
        onClose?.(arrayCopy);
    };

    const filterNotifications = (newNotifications: Notification[]) => {
        if (!Array.isArray(newNotifications)) newNotifications = [newNotifications];

        let data: NotificationData = {};

        newNotifications.forEach(notification => {
            data[notification.notificationType] = notification;
        });
        notifications.forEach(notification => {
            if (!data[notification.notificationType])
                //don't exists
                data[notification.notificationType] = notification;
            else {
                //already exists => need to check which one to keep by importance
                data[notification.notificationType] =
                    (data[notification.notificationType] as Notification).importance > notification.importance
                        ? data[notification.notificationType]
                        : notification;
            }
        });
        return Object.values(data);
    };

    const addBanner = (evt: CustomEvent) => {
        const data = filterNotifications(evt.detail);
        const newNotifications = [...data.map(notification => ({ ...notification }))];

        setNotifications(newNotifications);
        onAdd?.(newNotifications);
    };

    useEffect(() => {
        ref.current = notifications;
    }, [notifications]);

    useEvent({ name: notificationsEvents.addBanner, handler: addBanner });
    const currentNotification = notifications[0];

    return (
        <ToastWrapper>
            {currentNotification && (
                <BannerToast
                    {...currentNotification}
                    visible={true}
                    onClose={onCloseHandler}
                    CloseActionComponent={getCloseComponent(dismissText)}
                    MessageComponent={
                        typeof currentNotification.MessageComponent === 'function'
                            ? currentNotification.MessageComponent()
                            : currentNotification.MessageComponent
                    }
                />
            )}
        </ToastWrapper>
    );
};

const getCloseComponent = (dismissText: string) => {
    return <CloseButton>{dismissText}</CloseButton>;
};

export default NotificationsManager;
